import React from 'react';
import { string, func } from 'prop-types';

import { Button, ButtonElement, Icon } from './styles';

function ButtonComp({
  icon,
  width,
  label,
  type,
  onClick,
  align,
  height,
  margin,
  borderRadius,
}) {
  const isHtmlButton = type === 'submit' || type === 'button';
  const ButtonComponent = isHtmlButton ? ButtonElement : Button;
  const buttonType = isHtmlButton ? type : undefined;
  // Para o estilo, usar 'primary' como padrão quando type for submit/button
  const buttonStyle = isHtmlButton ? 'primary' : type;

  return (
    <ButtonComponent
      width={width}
      type={buttonType}
      buttonStyle={buttonStyle}
      onClick={onClick}
      align={align}
      height={height}
      margin={margin}
    >
      {icon !== null && <Icon src={icon} />} {label}
    </ButtonComponent>
  );
}

export default ButtonComp;

ButtonComp.propTypes = {
  width: string,
  height: string,
  label: string.isRequired,
  type: string,
  margin: string,
  onClick: func,
  icon: string,
  align: string,
};

ButtonComp.defaultProps = {
  width: null,
  icon: null,
  height: null,
  margin: 0,
  align: null,
  type: 'primary',
  onClick: () => {},
};
